import api from './api';
import { UploadedFile } from '../types';

export const uploadService = {
  uploadFile: async (file: File): Promise<UploadedFile> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post<UploadedFile>('/uploads', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  getUploads: async (): Promise<UploadedFile[]> => {
    const response = await api.get<UploadedFile[]>('/uploads');
    return response.data;
  },

  getUpload: async (id: number): Promise<UploadedFile> => {
    const response = await api.get<UploadedFile>(`/uploads/${id}`);
    return response.data;
  },

  deleteUpload: async (id: number): Promise<{ message: string; deletedPredictionsCount?: number }> => {
    const response = await api.delete(`/uploads/${id}`);
    return response.data;
  },
};

